import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeedSection from "./components/FeedSection";
import RankSection from "./components/RankSection";
import FeaturesSection from "./components/FeaturesSection";
import VoicesSection from "./components/VoicesSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <FeedSection />
        <RankSection />
        <FeaturesSection />
        <VoicesSection />
        <FaqSection />
      </main>
      <SiteFooter />

      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all duration-300 hover:bg-primary-600 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl" aria-hidden="true" />
      </button>
    </div>
  );
}